var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4194_33271)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 128,
    height: 128,
    rx: 24,
    fill: "#D4E8E0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6885 36.2426C83.6747 36.2426 74.7541 45.2572 74.7541 56.3869V76.5312H114.623V56.3869C114.623 45.2572 105.702 36.2426 94.6885 36.2426Z",
    fill: "#117249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7541 76.5312H54.8197C43.8059 76.5312 34.8853 85.5457 34.8853 96.6755C34.8853 107.805 43.8059 116.82 54.8197 116.82H74.7541V76.5312Z",
    fill: "#1DBF79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.623 76.5312H74.7541V116.82H109.639C111.01 116.82 112.256 116.253 113.165 115.347C114.062 114.44 114.623 113.181 114.623 111.784V76.5312Z",
    fill: "#03AA45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 14.5,
    width: 127,
    height: 127,
    rx: 23.5,
    stroke: "#117249",
    strokeOpacity: 0.15,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4194_33271",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4194_33271"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4194_33271",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFrame);
export default __webpack_public_path__ + "static/media/logoFrame.e78e46fed105e43be975af34c13cfdfd.svg";
export { ForwardRef as ReactComponent };